import React from 'react';
import { CheckCircle2 } from 'lucide-react';
export function SolutionSection() {
  const benefits = ['Sistema paso a paso para organizar tu freezer', 'Método para cocinar una vez y resolver varios días', 'Organización de compras y stock', 'Ideas prácticas aplicables a tu día a día', 'Estrategia para ahorrar tiempo y plata', 'Acceso inmediato'];
  return <section className="w-full bg-peach py-16 px-4 flex flex-col items-center" data-id="element-225">
      <div className="max-w-4xl w-full" data-id="element-226">
        <div className="text-center mb-12" data-id="element-227">
          <h2 className="text-4xl md:text-5xl font-extrabold text-brown-800 mb-6" data-id="element-228">
            FREEZER INTELIGENTE
          </h2>
          <p className="text-xl md:text-2xl font-bold text-brown-800 max-w-3xl mx-auto mb-4" data-id="element-229">
            El sistema simple para dejar de improvisar comidas y empezar a
            resolver tu semana con orden.
          </p>
          <p className="text-lg text-brown-600 max-w-2xl mx-auto" data-id="element-230">
            No es teoría. No son recetas sueltas. Es un sistema práctico que
            podés aplicar desde el día uno.
          </p>
        </div>

        <div className="bg-white rounded-2xl p-8 md:p-10 shadow-lg border border-gold-400/30 max-w-2xl mx-auto" data-id="element-231">
          <h3 className="font-bold text-2xl text-brown-800 mb-8 text-center border-b border-gray-100 pb-4" data-id="element-232">
            Lo que recibís
          </h3>
          <ul className="space-y-4" data-id="element-233">
            {benefits.map((benefit, index) => <li key={index} className="flex items-start gap-3" data-id="element-234">
                <CheckCircle2 className="text-green-600 shrink-0 mt-0.5" size={24} data-id="element-235" />
                <span className="text-brown-800 font-medium text-lg" data-id="element-236">
                  {benefit}
                </span>
              </li>)}
          </ul>
        </div>

        <div className="mt-12 flex justify-center" data-id="element-237">
          <a href="#compra" className="bg-gradient-to-r from-gold-400 to-gold-500 text-white font-bold text-lg py-4 px-8 rounded-full shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300 w-full max-w-md text-center" data-id="element-238">
            👉 VER OFERTA COMPLETA
          </a>
        </div>
      </div>
    </section>;
}